module.exports = __webpack_public_path__ + "img/pic1.b0329eda.png";